import { useState, useEffect } from 'react';
import { api, apis } from 'api';
const contactApi = api.requireLogicalApi(apis.contactApiImpl);
export function useMemberList(email) {
    const [members, setMembers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    useEffect(() => {
        if (!email)
            return;
        let cancelled = false;
        setLoading(true);
        setError(null);
        contactApi
            .getMaillistMember(email)
            .then(res => {
            if (cancelled)
                return;
            const raw = res.data;
            const list = raw === null || raw === void 0 ? void 0 : raw.member_list;
            if (!list) {
                setError(res.message || '获取成员失败');
                return;
            }
            const briefs = list.map(m => ({
                name: m.nickname || m.account_name,
                email: `${m.account_name}@${m.domain}`,
            }));
            setMembers(briefs);
        })
            .catch(e => {
            if (!cancelled)
                setError(e.message || '获取成员失败');
        })
            .finally(() => {
            if (!cancelled)
                setLoading(false);
        });
        return () => {
            cancelled = true;
        };
    }, [email]);
    return { members, loading, error };
}
